import React from 'react';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
import { S } from './style';
import { TriangleLeft, TriangleRight } from '../../Icon';
const iconStyle = {
    width: '18px',
    height: '35px',
    color: SEMANTIC_COLORS.PRIMARY_ICON,
    flexShrink: 0,
};
export const PrevButton = ({ isDisabled, onButtonClick }) => (<S.Layout disabled={isDisabled} onClick={onButtonClick}>
    <TriangleLeft style={iconStyle}/>
  </S.Layout>);
export const NextButton = ({ isDisabled, onButtonClick }) => (<S.Layout disabled={isDisabled} onClick={onButtonClick}>
    <TriangleRight style={iconStyle}/>
  </S.Layout>);
